import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AuthApiService } from 'features/auth/api/auth-api.service';
// ../api/auth-api.service
export const useCreateUserClients = () => {
  const { message } = App.useApp();
  const { createClients } = AuthApiService();

  return useMutation(
    (payload: any) => {
      return createClients(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        message.success('User Created Successfully.');
      },
    },
  );
};
